require('dotenv').config()

const prod = {
    mapPanel: {
        BING_MAP_KEY: 'Avhe78JjQnzMJ30O9VC80_qcdZhm9edm56GlwhhUo5IcWBHS5_TPBeheN1dZSqx_',
        MAPBOX_MAP_KEY: 'pk.eyJ1IjoiY2Fwb290aSIsImEiOiJjazcwbmtsOWYwMGRvM2RwbzdoMDRmcGE3In0.Wb-yoGrHWJuUBdEpg66NVw'
    },
    api: {
        URL: '/api'
    },
    static_files: {
        URL: '/static_dj/'
    }
};

const dev = {
    mapPanel: {
        BING_MAP_KEY: 'Avhe78JjQnzMJ30O9VC80_qcdZhm9edm56GlwhhUo5IcWBHS5_TPBeheN1dZSqx_',
        MAPBOX_MAP_KEY: 'pk.eyJ1IjoiY2Fwb290aSIsImEiOiJjazcwbmtsOWYwMGRvM2RwbzdoMDRmcGE3In0.Wb-yoGrHWJuUBdEpg66NVw'
    },
    api: {
        URL: 'http://localhost/api'
    },
    static_files: {
        URL: 'http://localhost/static_dj/'
    }
};

// console.log(process.env.REACT_APP_STAGE);

const config = process.env.REACT_APP_STAGE === 'staging'
    ? dev
    : prod;

    
export const appConfig = {
    // Add common config values here
    MAX_ATTACHMENT_SIZE: 5000000,
    ...config
};
